module.exports = __webpack_public_path__ + "static/img/icon3_on.445730fd.png";